import { NgModule } from '@angular/core';

import { RedirectService } from './services';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [RedirectService],
})
export class RedirectServiceModule {}
